<template>
  <el-container class="help-wrap">
    <el-header class="header">
      <div id="headerbar">
        <div @click="goHome" class="logo">
          <img src="../../assets/images/logo_white.png" />
        </div>
        <div class="account">
          <a @click="goHome" class="help-a">返回首页</a>
          <a @click="goHelp" class="help-a">帮助文档</a>
          <img
            src="../../assets/images/avatar.png"
            style="width:24px;height:24px;"
          />
          <span style="margin-left:8px;">{{ userName }}</span>
          <a @click="logout" style="cursor:pointer;margin-left:20px;color:#999"
            >退出</a
          >
        </div>
      </div>
    </el-header>
    <el-container>
      <el-aside class="sidebar" width="200px">
        <el-menu class="menu help-menu" router :default-active="$route.path">
          <el-submenu index="0">
            <template slot="title">
              <img
                src="../../assets/images/menu1.svg"
                style="margin-right:10px;"
              />
              <span>图片模板管理</span>
            </template>
            <el-menu-item index="/help/templateList">
              <span slot="title">如何制作图片模板</span>
            </el-menu-item>
            <el-menu-item index="/help/templatePrivate">
              <span slot="title">如何应用图片模板</span>
            </el-menu-item>
            <!-- <el-menu-item index="/template/group">
                            <span slot="title">模板组列表</span>
                        </el-menu-item> -->
          </el-submenu>
          <el-submenu index="1">
            <template slot="title">
              <img
                src="../../assets/images/menu1.svg"
                style="margin-right:10px;"
              />
              <span>视频模版管理</span>
            </template>
            <el-menu-item index="/help/videoList">
              <span slot="title">如何制作视频模板</span>
            </el-menu-item>
            <el-menu-item index="/help/videoTemplate">
              <span slot="title">如何应用视频模板</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main class="main">
        <div class="title">{{ $route.meta.title }}</div>
        <router-view class="content" />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import config from 'utils/config';

export default {
  data() {
    return {
      userName: ''
    };
  },
  mounted() {
    this.userName = config.USER_NAME;
  },
  methods: {
    logout() {
      localStorage.removeItem('accessToken');
      window.location.href = '/login';
    },
    goHelp() {
      this.$router.push('/help');
    },
    goHome() {
      this.$router.push('/template/list');
    }
  }
};
</script>

<style scoped lang="scss">
.help-wrap {
  color: rgba(0, 0, 0, 0.65);
  line-height: 2;

  .content {
    padding: 20px 40px;
    font-size: 14px;
    height: calc(100vh - 350px);
  }
}
.title {
  padding: 16px 32px;
  background: #fff;
}
.main {
  padding: 0;
  background: #f0f2f5;
}

:global(.el-menu) {
  background: none;
  border: 0;
}
:global(.el-menu-item) {
  color: #ffffff;
  height: 36px;
  line-height: 36px;
  margin: 10px;
  padding-left: 10px !important;
  :global(i) {
    color: #fff;
  }
  &:focus,
  &:hover {
    background-color: transparent;
  }
  &.is-active {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
  }
}
.logo {
  width: 200px;
  height: 100%;
  font-size: 30px;
  color: #ffffff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.header {
  font-size: 20px;
  line-height: 40px;
  padding: 0;
  box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.12);
  z-index: 100;
  display: flex;
  justify-content: space-between;
}
.account {
  display: flex;
  align-items: center;
  font-size: 14px;
  padding-right: 25px;
  justify-content: space-between;
}
.sidebar {
  background: #4a90e2;
}
.title {
  font-size: 20px;
  font-weight: bold;
}
.help-a {
  cursor: pointer;
  margin-right: 20px;
  color: blue;
  text-decoration: underline;
}
</style>
